import { inject } from '@angular/core';

import { ToastService, ToastType } from '@hglobal/fin-ui';
import { signalStoreFeature, withMethods } from '@ngrx/signals';

import { StoreHelperService } from '..';

export function withRequestHandler() {
  return signalStoreFeature(
    withMethods(() => {
      const storeHelper = inject(StoreHelperService);
      const toast = inject(ToastService);

      return {
        showSuccessToast: (messageKey: string, titleKey?: string) => {
          toast.show({
            type: ToastType.Success,
            message: messageKey,
            title: titleKey,
          });
        },
        handleError: storeHelper.handleError,
      };
    }),
  );
}
